import { useLocation, useNavigate } from "react-router-dom"
import { getAssetUrl } from "@/utils/assets"

type TabKey = "home" | "explore" | "profile" | "connect" | "chat"

const TAB_ROUTE_MAP: Record<TabKey, string[]> = {
  home: ["/"],
  explore: ["/learn-and-practice", "/rituals"],
  profile: ["/my-rituality", "/settings"],
  connect: ["/connect", "/communities"],
  chat: ["/chats"],
}

const TAB_ICONS: Record<TabKey, string> = {
  home: "mobile_home_icon.svg",
  explore: "mobile_learn_icon.svg",
  profile: "mobile_myrituality_icon.svg",
  connect: "mobile_connect_icon.svg",
  chat: "mobile_chat_icon.svg",
}

const TABS: { key: TabKey; label: string }[] = [
  { key: "home", label: "Home" },
  { key: "explore", label: "Explore" },
  { key: "profile", label: "Profile" },
  { key: "connect", label: "Connect" },
  { key: "chat", label: "Chat" },
]

interface MobileBottomBarProps {
  chatBadgeCount?: number
}

export function MobileBottomBar({ chatBadgeCount = 0 }: MobileBottomBarProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const bottom_bg = getAssetUrl("bottom_background.png")

  const activeTab = getActiveTab(location.pathname)

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 rounded-t-[30px] h-[85px] bg-[#020202] border-t border-[#F2F0EB26] bg-cover"
      style={{
        backgroundImage: `url(${bottom_bg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex items-center justify-around pb-4.5 pt-3.75">
        {TABS.map(({ key, label }) => {
          const isActive = activeTab === key
          return (
            <button
              key={key}
              onClick={() => navigate(getTabRoute(key))}
              className="relative flex flex-col items-center justify-center gap-2.5 w-[60px] h-[51px]"
            >
              <div className="relative">
                <img
                  src={getAssetUrl(TAB_ICONS[key])}
                  alt={label}
                  className="w-7.5 h-7.5"
                  style={{ opacity: isActive ? 1 : 0.4 }}
                />
                {key === "chat" && chatBadgeCount > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-brand-terracotta-bright text-[10px] font-semibold text-white px-1">
                    {chatBadgeCount > 99 ? "99+" : chatBadgeCount}
                  </span>
                )}
              </div>
              <span
                className={`text-[9px] leading-normal uppercase font-semibold ${isActive ? "font-semibold" : ""}`}
                style={{ color: isActive ? "#F2F0EB" : "#F2F0EB66" }}
              >
                {label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}

function getActiveTab(pathname: string): TabKey | null {
  for (const [tab, routes] of Object.entries(TAB_ROUTE_MAP)) {
    for (const route of routes) {
      if (route === "/" ? pathname === "/" : pathname.startsWith(route)) {
        return tab as TabKey
      }
    }
  }
  return null
}

function getTabRoute(key: TabKey): string {
  const routes: Record<TabKey, string> = {
    home: "/",
    explore: "/learn-and-practice",
    chat: "/chats",
    connect: "/connect",
    profile: "/my-rituality",
  }
  return routes[key]
}
